const autoplaceholder = 'autoplaceholder';

export const autoplaceholderModel = `${autoplaceholder}Model`;
export const autoplaceholderDataAttribute = `${autoplaceholder}Data`;

export const cls_autoplaceholder = autoplaceholder;
export const cls_autoplaceholderContainer = `${autoplaceholder}-container`;
export const cls_autoplaceholderToken = `${autoplaceholder}-token`;

export const autoplaceholderRE = new RegExp(
    `<(?:span|div)\\s+class="\\s?${cls_autoplaceholder}(?:-token)?\\s*`,
    'gim'
);
